import { getGlobalSettings } from "../settings.js"
import * as translations_editor from "./translations_editor.js"
import { Innosoft_WebCRM_Statistics_Controllers_CategoryController as CategoryController } from "../generated_api/generated_api.js"
import { Button } from "../../core/components/button.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { FullHeightContainer } from "../../core/components/FullHeighContainer.js"
import { Menu, EntryType } from "../../core/components/menu.js"
import React from "react";
export class CategoryEditor extends React.Component<any, any>{
    constructor(props: any, context: any) {
        super(props, context);
        let globalSettings = getGlobalSettings();
        this.state = { categories: [], basePath: globalSettings.GetSettings().INNO_BASE_PATH };
    }

    componentDidMount() {
        new CategoryController().GetCategories((categories) => {
            this.setState({ categories: categories });
        });
    }

    handleShowTranslation = (category) => {
        this.setState({ showTranslationsPicker: true, category: category });
    }

    renderCategorie = (category) => {
        return (
            <tr>
                <td>{category.Id}</td>
                <td>{category.Name}</td>
                <td>
                    <Button iconName="search" title="Suche" handleClick={this.handleShowTranslation.bind(this, category)}></Button>
                </td>
            </tr>
        )
    }

    handleCloseTranslationDialog = () => {
        this.setState({ showTranslationsPicker: false });
    }

    handleSaveCategories = () => {
        new CategoryController().SaveCategories(this.state.categories, (result) => {
            NotificationHelper.showSuccessMessage("Saved successfully");
            this.setState({ categories: result });
        });
    }

    handleAddNewCategory = () => {
        let categories = this.state.categories;
        categories.push({ Id: null, Name: "new" });
        this.setState({ categories: categories });
    }

    handleSaveTranslation = (result: string) => {
        this.setState({ showTranslationsPicker: false });
        this.state.category.Name = '{{{' + result + '}}}';
        this.forceUpdate();
    }

    render() {
        let categories = this.state.categories.map(this.renderCategorie);
        let translationsEditor = this.state.showTranslationsPicker ? <translations_editor.TranslationsEditor contextVariables={{ INNO_BASE_PATH: this.state.basePath }} onClose={this.handleCloseTranslationDialog} onSave={this.handleSaveTranslation} /> : null;
        return (
            <FullHeightContainer>
                <Menu entries={[
                    { type: EntryType.Save, onClick: this.handleSaveCategories },
                    { text: "Add new", onClick: this.handleAddNewCategory },
                ]}
                    onSelect={() => { }}
                    enableMenuItem={() => true}
                    handleEval={() => { }} />

                <table style={{ marginLeft: "5px" }}>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th />
                    </tr>
                    <tbody>
                        {categories}
                        {translationsEditor}
                    </tbody>
                </table>
            </FullHeightContainer>
        )
    }
};

